export const environment = {
  configuration: 'production',
  production: true,
  domain: 'https://azoneconstruction.co.uk/api',
  assets: 'https://azoneconstruction.co.uk/api/media/file/',
  video: 'https://azoneconstruction.co.uk/api/media/video/',
  download: 'https://azoneconstruction.co.uk/api/media/download/',
  view: 'https://azoneconstruction.co.uk/api/media/view/',
  email_api: 'https://azoneconstruction.co.uk',
  recaptchaSiteKey: '6LfcSxwsAAAAAGtHIBNQ34zwmP-viTVFQLk-JCLQ',
  recaptchaSecretKey: '6LfcSxwsAAAAAG-dSqaC88iLUHf1e0YuAoJ5bj_x',
};
